import { render, staticRenderFns } from "./FcmImageEditor.vue?vue&type=template&id=48d1fe64"
import script from "./FcmImageEditor.vue?vue&type=script&lang=js"
export * from "./FcmImageEditor.vue?vue&type=script&lang=js"
import style0 from "./FcmImageEditor.vue?vue&type=style&index=0&id=48d1fe64&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports